import * as THREE from "three";
import React, { useRef, useEffect, useState } from "react";
import { useThree, useFrame, extend } from "react-three-fiber";
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls";
import useStore from "../store";

extend({ OrbitControls });

const MOVE_SPEED = 0.05;
const playerWorldPos = new THREE.Vector3();
const origin = new THREE.Vector3(0, 0, 0);
const vectorStart = new THREE.Vector3();
const vectorEnd = new THREE.Vector3();
const raycaster = new THREE.Raycaster();
const forwardWorldPos = new THREE.Vector3();
let angle = null;
let intersects = [];

const direction = new THREE.Vector3();
const FIXED_CAMERA_OFFSET = 4;
const offsetVector = new THREE.Vector3(FIXED_CAMERA_OFFSET, 4, FIXED_CAMERA_OFFSET);

const Controls = (props) => {
  const { gl, camera } = useThree();
  const ref = useRef();
  const controls = useStore((state) => state.controls);
  const debug = useStore((state) => state.debug);
  const { setPlayerWorldPosition } = useStore(state => state.actions);
  const { player, globe } = props;

  const cameraPos = useRef();
  const forward = useRef();
  const backward = useRef();
  const left = useRef();
  const right = useRef();

  useFrame(() => {
    // CODE FOR UPDATING PLAYER POS
    // TODO: change up / down to a single vertical speed number
    const moveSpeed = controls.up ? MOVE_SPEED : controls.down ? -MOVE_SPEED : 0;
    const deltaRotationY = controls.right ? -MOVE_SPEED : controls.left ? MOVE_SPEED : 0;

    player.current.rotateY(deltaRotationY);
    player.current.getWorldPosition(playerWorldPos);
    setPlayerWorldPosition(playerWorldPos);

    vectorStart.copy(playerWorldPos);
    forward.current.getWorldPosition(forwardWorldPos);

    raycaster.set(origin, forwardWorldPos.normalize());
    intersects = [];
    raycaster.intersectObject(globe.current, true, intersects);

    if (debug.logging) {
      console.log(intersects);
    }

    if (controls.up) {
      vectorEnd.copy(forwardWorldPos);

      angle = vectorStart.normalize().angleTo(vectorEnd.normalize());

      player.current.rotateX(angle);
      player.current.position.copy(intersects[0].point);
    }
    
    // CODE FOR UPDATING CAMERA
    ref.current.update();
    direction.subVectors( camera.position, playerWorldPos );
    direction.normalize().multiplyScalar(FIXED_CAMERA_OFFSET)
    // direction.normalize().multiply( offsetVector );
    // direction.setY(2) // TODO: maintain angle to player
    camera.position.copy( direction.add( playerWorldPos ));
    camera.lookAt(playerWorldPos);
    // TODO: this breaks the orbit controls
    // camera.up.copy(playerWorldPos.normalize()); // maintain up axis when player crosses poles


  });
  return (
    <>
      { debug.arrows && ["red", "green", "blue", "purple"].map((color, i) => {
        let x = 0,
          z = 0;
        switch (i) {
          case 0:
            z = MOVE_SPEED;
            break;
          case 1:
            x = -MOVE_SPEED;
            break;
          case 2:
            z = -MOVE_SPEED;
            break;
          case 3:
            x = MOVE_SPEED;
            break;
          default:
            break;
        }

        return (
          <mesh key={i} position={[x * 20, -1, z * 20]}>
            <boxBufferGeometry attach="geometry" args={[0.2, 0.2, 0.2]} />
            <meshBasicMaterial attach="material" color={color} />
          </mesh>
        );
      })}
      <object3D position={[0, 0, MOVE_SPEED]} ref={forward} />
      <object3D position={[0, 0, -MOVE_SPEED]} ref={backward} />
      <object3D position={[-MOVE_SPEED, 0, 0]} ref={left} />
      <object3D position={[MOVE_SPEED, 0, 0]} ref={right} />
      <object3D position={[0, 0, -2]} ref={cameraPos} />
      <orbitControls
        ref={ref}
        args={[camera, gl.domElement]}
        {...props}
      />
    </>
  );
};

const PlayerOrbitControls = (props) => {
  return (
    <Controls
      enableKeys={false}
      enablePan={false}
      enableZoom={false}
      maxPolarAngle={1.1 * (Math.PI / 2)}
      enableDamping
      dampingFactor={0.5}
      rotateSpeed={0.5}
      { ...props }
    />
  );
};

export default PlayerOrbitControls;